export default __webpack_public_path__ + "static/media/Resource-Icons-2to3-transparent.e9601751.png";